<template>
  <td v-html="html"></td>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
    props: ['content'],
    computed: {
      html () {
        return this.content !== null ? this.content : defaultNullHtml();
      }
    }
};
</script>
